import React, { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import MainLayout from './components/layout/MainLayout';
import ProtectedRoute from './components/common/ProtectedRoute';
import { PageLoader as Loader } from './components/common/Loading';

// Lazy load pages
const Home = lazy(() => import('./pages/Home'));
const KnowledgeBasePage = lazy(() => import('./pages/KnowledgeBasePage'));
const CategoryPage = lazy(() => import('./pages/CategoryPage'));
const ArticlePage = lazy(() => import('./pages/ArticlePage'));
const SearchPage = lazy(() => import('./pages/SearchPage'));
const TicketsPage = lazy(() => import('./pages/TicketsPage'));
const NewTicketPage = lazy(() => import('./pages/NewTicketPage'));
const TicketDetailPage = lazy(() => import('./pages/TicketDetailPage'));
const NotFoundPage = lazy(() => import('./pages/NotFoundPage'));

// Loading fallback: the rippling E
const PageLoader = () => <Loader message="Loading" />;

function App() {
  return (
    <MainLayout>
      <Suspense fallback={<PageLoader />}>
        <Routes>
          {/* Home */}
          <Route path="/" element={<Home />} />

          {/* Knowledge Base (Requires Authentication) */}
          <Route
            path="/kb"
            element={
              <ProtectedRoute title="Sign in to access the Knowledge Base">
                <KnowledgeBasePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/kb/category/:slug"
            element={
              <ProtectedRoute title="Sign in to view this category">
                <CategoryPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/kb/article/:slug"
            element={
              <ProtectedRoute title="Sign in to read this article">
                <ArticlePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/kb/search"
            element={
              <ProtectedRoute title="Sign in to search articles">
                <SearchPage />
              </ProtectedRoute>
            }
          />

          {/* Tickets (Authenticated) */}
          <Route path="/tickets" element={<TicketsPage />} />
          <Route path="/tickets/new" element={<NewTicketPage />} />
          <Route path="/tickets/:id" element={<TicketDetailPage />} />

          {/* 404 */}
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </MainLayout>
  );
}

export default App;
